import angular from 'angular'

import component from './empty-info.component'

export default angular.module('empty-info', [])
  .directive('emptyInfo', component)
  .name
